import { ControlFlow } from "./chat-msg-types";

export interface ChatAuthenticationState {
    killSwitchSendOtpInfo?: string;
    canClickResend?: boolean;
    canClickSubmit?: number;
    resetOtp?: boolean;
}

export const initialChatAuthenticationState: ChatAuthenticationState = {
    killSwitchSendOtpInfo: "",
    canClickResend: true,
    canClickSubmit: 3,
    resetOtp: false
}

export interface OtpReq {
    actionId?: string;
    type: string;
    otp?: string;
    controlFlow?:ControlFlow;
    accessCodeLoginReq?: AccessCodeReqBody;
}

export interface AccessCodePayload {
    accessCode?: string,
    pin?: string,
    type: string,
    actionId?: string
}

export interface AccessCodeReqBody {
    loginId?: string,
    rId?: string,
    pString?: string,
    cString?: string,
    password?: string
}

export interface GetAccessCodeParam {
    modulusString?: string,
    exponent?: string,
    minLength?: string,
    maxLength?: string,
    maxLoginIdLength?: string,
    randomID?: string,
    randomNumber?: string,
    responseCode?: string
}